/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.import { resourceConfig } from './resource.config';
import { resourceConfig } from './resource.config';
import { AuthConfig } from './confg';

const devAuthConfig: AuthConfig = {
  domain: 'dev-c2oymhxblfvzum2l.eu.auth0.com',
  clientId: 'dJXvEvzZERJv7l5uEyzRnmEKVPkuhNsw',
  clintSecret: 'aofIm2a1z5ZCuLyBs7M_1SpIv0O4SX_wqhDL3bXhmhqY0TN1-CKTQE33r4NVWKvs',
  ramuUrl: 'https://dev.ramu.dacoval.com',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://dev.portal.dacoval.com',
    useCookiesForTransactions: true,
    SameSite: 'None',
    environment: 'DEV'
  },
};

const qaAuthConfig: AuthConfig = {
  domain: 'dacoval-qa.eu.auth0.com',
  clientId: 'fWSlQkHjfCxjGqcp2CZy9TnlMxxuWDDp',
  clintSecret: 'HRkCzIcaWGetoleEuR856yqv9s_hARRvpXxuzkVYhE50agxPB_wLNzfYScGjJbOW',
  ramuUrl: 'https://qa.ramu.dacoval.com',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://qa.portal.dacoval.com',
    cookieDomain: '.dacoval.com',
    useCookiesForTransactions: true,
    SameSite: 'None',
    environment: 'QA'
  },
};

const uatAuthConfig: AuthConfig = {
  domain: 'dacoval-dev.eu.auth0.com',
  clientId: 'xkcj8AIeAHcfHEeuLVlNALbRnAP2pzg9',
  clintSecret: 'h2-vmNyJXZ1p7SEsNpxugDT8YOA3Jiqdk_wKNPg1OED7PQJzBBParek78BhGir4v',
  ramuUrl: 'https://uat.ramu.dacoval.com',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://uat.portal.dacoval.com',
    cookieDomain: '.dacoval.com',
    useCookiesForTransactions: true,
    SameSite: 'None',
    environment: 'UAT'
  },
};

const prodAuthConfig: AuthConfig = {
  domain: 'dacoval-prod.eu.auth0.com',
  clientId: 'qWFFwg2fuE1tW9vevzUvwVX838CAZBGO',
  clintSecret: 'H2OemlFyoWfB1HqDL3XQMTE9Yc3veykY2J3LXYTp_m8zSEWsOVUfo_RAlZQQG7U4',
  ramuUrl: 'https://ramu.dacoval.com',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://portal.dacoval.com',
    cookieDomain: '.dacoval.com',
    useCookiesForTransactions: true,
    SameSite: 'None',
    environment: 'PROD',
  },
};

// const devPlaformConfig: PlatformConfig = {
//   platformUrl: 'https://dev.platform.dacoval.com',
//   platformApi: 'https://dev.platform.dacoval.com/dmint-platform/api/v1',
// };

// const qaPlaformConfig: PlatformConfig = {
//   platformUrl: 'https://dmintplatformfrontend-qa.azurewebsites.net',
//   platformApi: 'https://dmintplatformfrontend-qa.azurewebsites.net/dmint-platform/api/v1',
// };

// const prodPlaformConfig: PlatformConfig = {
//   platformUrl: 'https://dmintplatformfrontend.azurewebsites.net',
//   platformApi: 'https://dmintplatformfrontend.azurewebsites.net/dmint-platform/api/v1',
// };

export function getConfig() {
  if (`${document.location.host}`.startsWith('portal')) {
    console.log('prod auth');
    return {
      ...prodAuthConfig,
    };
  }
  if (`${document.location.host}`.startsWith('dev.portal')) {
    console.log('dev auth');
    return {
      ...devAuthConfig,
    };
  }
  if (`${document.location.host}`.startsWith('qa.portal')) {
    console.log('qa auth');
    return {
      ...qaAuthConfig,
    };
  }

  if (`${document.location.host}`.startsWith('uat.portal')) {
    console.log('uat auth');
    return {
      ...uatAuthConfig,
    };
  }

  return {
    ...devAuthConfig,
  };
}

// export function getPlatformConfig(): PlatformConfig {
//   if (`${document.location.host}`.startsWith('portal')) {
//     return {
//       ...prodPlaformConfig,
//     };
//   }
//   if (`${document.location.host}`.startsWith('dev.portal')) {
//     return {
//       ...devPlaformConfig,
//     };
//   }
//   if (`${document.location.host}`.startsWith('qa.portal')) {
//     return {
//       ...qaPlaformConfig,
//     };
//   }
//   return {
//     ...devPlaformConfig,
//   };
// }

export const environment = {
  production: false,
  resource: resourceConfig,
  domain: `${document.location.protocol}//${document.location.host}`,
  auth0: getConfig(),
};
